module.exports = __webpack_public_path__ + "img/rethinkp2p.cba5358e.png";